module.exports = __webpack_public_path__ + "static/robots-fb5f84ce975a5a4dc828b6dd39ecddcb.jpg";